import React, { useCallback, useRef } from 'react';
import ReactSelect, { components } from 'react-select';

import { ChevronDownIcon } from '../../../assets/svg/SVGComponents';

interface OptionType {
  label: string;
  value: string | number;
}

interface Props {
  name: string;
  dropdownIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  iconLeft?: React.FC<React.SVGProps<SVGSVGElement>>;
  isMulti?: boolean;
  defaultValue?: any;
  options?: OptionType[];
  [key: string]: any;
}

const Select: React.FC<Props> = ({
  name,
  iconLeft: IconLeft,
  dropdownIcon: Icon,
  isMulti = false,
  defaultValue,
  ...rest
}) => {
  const selectRef = useRef<any>(null);

  const DropdownIndicator = useCallback(
    (props: any) => {
      return (
        <components.DropdownIndicator {...props}>
          {Icon ? (
            <Icon width="1.22rem" fill="none" strokeWidth={2} />
          ) : (
            <ChevronDownIcon width="1.22rem" strokeWidth={2} />
          )}
        </components.DropdownIndicator>
      );
    },
    [Icon],
  );

  const Control = useCallback(
    (props: any) => {
      return (
        <components.Control {...props}>
          {IconLeft && (
            <IconLeft
              width="1.33rem"
              stroke="#323650"
              fill="none"
              strokeWidth={2}
            />
          )}
          {props.children}
        </components.Control>
      );
    },
    [IconLeft],
  );

  return (
    <ReactSelect
      defaultValue={defaultValue}
      ref={selectRef}
      classNamePrefix="react-select"
      components={{ DropdownIndicator, Control }}
      isMulti={isMulti}
      {...rest}
    />
  );
};

export default Select;
